import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './AppRouter';
const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(<AppRouter data-id="element-505" />);
}